import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppBreadcrumbs, LazyAppFooter, LazyAppHeader, LazyFrontendDetailPage, LazyFrontendLandingPage, LazyFrontendNavigationPage, LazyProductQuantityUpdateButton, LazySearchBar, LazySearchBarItem, LazySwNewsletterForm, LazyAccountAddressCard, LazyAccountAddressCardSkeleton, LazyAccountAddressForm, LazyAccountLoginCard, LazyAccountOrderSummary, LazyAccountPaymentCard, LazyAccountUpdateProfile, LazyAccountPasswordChangeCard, LazyAccountPasswordRecoveryCard, LazyAccountRegisterCard, LazyAccountRegisterForm, LazyAccountRegisterBusinessForm, LazyAccountRegisterGuestForm, LazyCartFees, LazyCartItem, LazyCartPromotionCode, LazyCartSidebar, LazyCartSummary, LazyCheckoutDeliveryMethodVenipakCourier, LazyCmsGenericBlock, LazyCmsPage, LazyCmsProductCard, LazyCmsSlider, LazyCmsVariantConfigurator, LazyCmsBlockGalleryBuybox, LazyCmsBlockImageCover, LazyCmsBlockImageThreeCover, LazyCmsBlockStovendoBanner, LazyCmsBlockTextTwoColumn, LazyCmsElementBuyBox, LazyCmsElementCategoryNavigation, LazyCmsElementCrossSelling, LazyCmsElementForm, LazyCmsElementImage, LazyCmsElementImageGallery, LazyCmsElementProductBox, LazyCmsElementProductDescriptionReviews, LazyCmsElementProductListing, LazyCmsElementProductSlider, LazyCmsElementSidebarFilter, LazyCmsElementText, LazyCmsFiltersProductListingFilter, LazyCmsFiltersProductListingFilters, LazyCmsListingFiltersFilterPrice, LazyCmsListingFiltersFilterProperties, LazyCmsListingFiltersFilterRating, LazyCmsListingFiltersFilterShippingFree, LazyCmsProductDescription, LazyCmsProductReviews, LazyCmsProductReviewsForm, LazyCmsSectionDefault, LazyCmsSectionSidebar, LazyErrorsMaintainMode, LazyErrorsRoutingNotFound, LazyNavigationElement, LazyNavigationElementDesktop, LazyNavigationVariantFlatElementDesktop, LazySharedPrice, LazySharedTransition, LazyCmsGenericElement, LazyCmsNoComponent, LazyCmsBlockCategoryNavigation, LazyCmsBlockCenterText, LazyCmsBlockCrossSelling, LazyCmsBlockCustomForm, LazyCmsBlockDefault, LazyCmsBlockForm, LazyCmsBlockImage, LazyCmsBlockImageBubbleRow, LazyCmsBlockImageFourColumn, LazyCmsBlockImageGallery, LazyCmsBlockImageHighlightRow, LazyCmsBlockImageSimpleGrid, LazyCmsBlockImageSlider, LazyCmsBlockImageText, LazyCmsBlockImageTextBubble, LazyCmsBlockImageTextCover, LazyCmsBlockImageTextGallery, LazyCmsBlockImageTextRow, LazyCmsBlockImageThreeColumn, LazyCmsBlockImageTwoColumn, LazyCmsBlockProductDescriptionReviews, LazyCmsBlockProductHeading, LazyCmsBlockProductListing, LazyCmsBlockProductSlider, LazyCmsBlockProductThreeColumn, LazyCmsBlockSidebarFilter, LazyCmsBlockText, LazyCmsBlockTextHero, LazyCmsBlockTextOnImage, LazyCmsBlockTextTeaser, LazyCmsBlockTextTeaserSection, LazyCmsBlockTextThreeColumn, LazyCmsBlockVimeoVideo, LazyCmsBlockYoutubeVideo, LazyCmsBlockHtml, LazyCmsElementCustomForm, LazyCmsElementHtml, LazyCmsElementImageGallery3dPlaceholder, LazyCmsElementImageSlider, LazyCmsElementManufacturerLogo, LazyCmsElementProductName, LazyCmsElementVimeoVideo, LazyCmsElementYoutubeVideo, LazyProductCardSkeleton, LazyAutoComplete, LazyCalendar, LazyCascadeSelect, LazyCheckbox, LazyCheckboxGroup, LazyChips, LazyColorPicker, LazyDatePicker, LazyDropdown, LazyFloatLabel, LazyFluid, LazyIconField, LazyIftaLabel, LazyInputChips, LazyInputGroup, LazyInputGroupAddon, LazyInputIcon, LazyInputMask, LazyInputNumber, LazyInputOtp, LazyInputSwitch, LazyInputText, LazyKnob, LazyListbox, LazyMultiSelect, LazyPassword, LazyRadioButton, LazyRadioButtonGroup, LazyRating, LazySelect, LazySelectButton, LazySlider, LazyTextarea, LazyToggleButton, LazyToggleSwitch, LazyTreeSelect, LazyButton, LazyButtonGroup, LazySpeedDial, LazySplitButton, LazyColumn, LazyRow, LazyColumnGroup, LazyDataTable, LazyDataView, LazyOrderList, LazyOrganizationChart, LazyPaginator, LazyPickList, LazyTree, LazyTreeTable, LazyTimeline, LazyVirtualScroller, LazyAccordion, LazyAccordionPanel, LazyAccordionHeader, LazyAccordionContent, LazyAccordionTab, LazyCard, LazyDeferredContent, LazyDivider, LazyFieldset, LazyPanel, LazyScrollPanel, LazySplitter, LazySplitterPanel, LazyStepper, LazyStepList, LazyStep, LazyStepItem, LazyStepPanels, LazyStepPanel, LazyTabView, LazyTabs, LazyTabList, LazyTab, LazyTabPanels, LazyTabPanel, LazyToolbar, LazyConfirmDialog, LazyConfirmPopup, LazyDialog, LazyDrawer, LazyDynamicDialog, LazyOverlayPanel, LazyPopover, LazySidebar, LazyFileUpload, LazyBreadcrumb, LazyContextMenu, LazyDock, LazyMenu, LazyMenubar, LazyMegaMenu, LazyPanelMenu, LazySteps, LazyTabMenu, LazyTieredMenu, LazyMessage, LazyInlineMessage, LazyToast, LazyGalleria, LazyImage, LazyImageCompare, LazyAvatar, LazyAvatarGroup, LazyBadge, LazyBlockUI, LazyChip, LazyInplace, LazyMeterGroup, LazyOverlayBadge, LazyScrollTop, LazySkeleton, LazyProgressBar, LazyProgressSpinner, LazyTag, LazyTerminal, LazyForm, LazyFormField } from '#components'
const lazyGlobalComponents = [
  ["AppBreadcrumbs", LazyAppBreadcrumbs],
["AppFooter", LazyAppFooter],
["AppHeader", LazyAppHeader],
["FrontendDetailPage", LazyFrontendDetailPage],
["FrontendLandingPage", LazyFrontendLandingPage],
["FrontendNavigationPage", LazyFrontendNavigationPage],
["ProductQuantityUpdateButton", LazyProductQuantityUpdateButton],
["SearchBar", LazySearchBar],
["SearchBarItem", LazySearchBarItem],
["SwNewsletterForm", LazySwNewsletterForm],
["AccountAddressCard", LazyAccountAddressCard],
["AccountAddressCardSkeleton", LazyAccountAddressCardSkeleton],
["AccountAddressForm", LazyAccountAddressForm],
["AccountLoginCard", LazyAccountLoginCard],
["AccountOrderSummary", LazyAccountOrderSummary],
["AccountPaymentCard", LazyAccountPaymentCard],
["AccountUpdateProfile", LazyAccountUpdateProfile],
["AccountPasswordChangeCard", LazyAccountPasswordChangeCard],
["AccountPasswordRecoveryCard", LazyAccountPasswordRecoveryCard],
["AccountRegisterCard", LazyAccountRegisterCard],
["AccountRegisterForm", LazyAccountRegisterForm],
["AccountRegisterBusinessForm", LazyAccountRegisterBusinessForm],
["AccountRegisterGuestForm", LazyAccountRegisterGuestForm],
["CartFees", LazyCartFees],
["CartItem", LazyCartItem],
["CartPromotionCode", LazyCartPromotionCode],
["CartSidebar", LazyCartSidebar],
["CartSummary", LazyCartSummary],
["CheckoutDeliveryMethodVenipakCourier", LazyCheckoutDeliveryMethodVenipakCourier],
["CmsGenericBlock", LazyCmsGenericBlock],
["CmsPage", LazyCmsPage],
["CmsProductCard", LazyCmsProductCard],
["CmsSlider", LazyCmsSlider],
["CmsVariantConfigurator", LazyCmsVariantConfigurator],
["CmsBlockGalleryBuybox", LazyCmsBlockGalleryBuybox],
["CmsBlockImageCover", LazyCmsBlockImageCover],
["CmsBlockImageThreeCover", LazyCmsBlockImageThreeCover],
["CmsBlockStovendoBanner", LazyCmsBlockStovendoBanner],
["CmsBlockTextTwoColumn", LazyCmsBlockTextTwoColumn],
["CmsElementBuyBox", LazyCmsElementBuyBox],
["CmsElementCategoryNavigation", LazyCmsElementCategoryNavigation],
["CmsElementCrossSelling", LazyCmsElementCrossSelling],
["CmsElementForm", LazyCmsElementForm],
["CmsElementImage", LazyCmsElementImage],
["CmsElementImageGallery", LazyCmsElementImageGallery],
["CmsElementProductBox", LazyCmsElementProductBox],
["CmsElementProductDescriptionReviews", LazyCmsElementProductDescriptionReviews],
["CmsElementProductListing", LazyCmsElementProductListing],
["CmsElementProductSlider", LazyCmsElementProductSlider],
["CmsElementSidebarFilter", LazyCmsElementSidebarFilter],
["CmsElementText", LazyCmsElementText],
["CmsFiltersProductListingFilter", LazyCmsFiltersProductListingFilter],
["CmsFiltersProductListingFilters", LazyCmsFiltersProductListingFilters],
["CmsListingFiltersFilterPrice", LazyCmsListingFiltersFilterPrice],
["CmsListingFiltersFilterProperties", LazyCmsListingFiltersFilterProperties],
["CmsListingFiltersFilterRating", LazyCmsListingFiltersFilterRating],
["CmsListingFiltersFilterShippingFree", LazyCmsListingFiltersFilterShippingFree],
["CmsProductDescription", LazyCmsProductDescription],
["CmsProductReviews", LazyCmsProductReviews],
["CmsProductReviewsForm", LazyCmsProductReviewsForm],
["CmsSectionDefault", LazyCmsSectionDefault],
["CmsSectionSidebar", LazyCmsSectionSidebar],
["ErrorsMaintainMode", LazyErrorsMaintainMode],
["ErrorsRoutingNotFound", LazyErrorsRoutingNotFound],
["NavigationElement", LazyNavigationElement],
["NavigationElementDesktop", LazyNavigationElementDesktop],
["NavigationVariantFlatElementDesktop", LazyNavigationVariantFlatElementDesktop],
["SharedPrice", LazySharedPrice],
["SharedTransition", LazySharedTransition],
["CmsGenericElement", LazyCmsGenericElement],
["CmsNoComponent", LazyCmsNoComponent],
["CmsBlockCategoryNavigation", LazyCmsBlockCategoryNavigation],
["CmsBlockCenterText", LazyCmsBlockCenterText],
["CmsBlockCrossSelling", LazyCmsBlockCrossSelling],
["CmsBlockCustomForm", LazyCmsBlockCustomForm],
["CmsBlockDefault", LazyCmsBlockDefault],
["CmsBlockForm", LazyCmsBlockForm],
["CmsBlockImage", LazyCmsBlockImage],
["CmsBlockImageBubbleRow", LazyCmsBlockImageBubbleRow],
["CmsBlockImageFourColumn", LazyCmsBlockImageFourColumn],
["CmsBlockImageGallery", LazyCmsBlockImageGallery],
["CmsBlockImageHighlightRow", LazyCmsBlockImageHighlightRow],
["CmsBlockImageSimpleGrid", LazyCmsBlockImageSimpleGrid],
["CmsBlockImageSlider", LazyCmsBlockImageSlider],
["CmsBlockImageText", LazyCmsBlockImageText],
["CmsBlockImageTextBubble", LazyCmsBlockImageTextBubble],
["CmsBlockImageTextCover", LazyCmsBlockImageTextCover],
["CmsBlockImageTextGallery", LazyCmsBlockImageTextGallery],
["CmsBlockImageTextRow", LazyCmsBlockImageTextRow],
["CmsBlockImageThreeColumn", LazyCmsBlockImageThreeColumn],
["CmsBlockImageTwoColumn", LazyCmsBlockImageTwoColumn],
["CmsBlockProductDescriptionReviews", LazyCmsBlockProductDescriptionReviews],
["CmsBlockProductHeading", LazyCmsBlockProductHeading],
["CmsBlockProductListing", LazyCmsBlockProductListing],
["CmsBlockProductSlider", LazyCmsBlockProductSlider],
["CmsBlockProductThreeColumn", LazyCmsBlockProductThreeColumn],
["CmsBlockSidebarFilter", LazyCmsBlockSidebarFilter],
["CmsBlockText", LazyCmsBlockText],
["CmsBlockTextHero", LazyCmsBlockTextHero],
["CmsBlockTextOnImage", LazyCmsBlockTextOnImage],
["CmsBlockTextTeaser", LazyCmsBlockTextTeaser],
["CmsBlockTextTeaserSection", LazyCmsBlockTextTeaserSection],
["CmsBlockTextThreeColumn", LazyCmsBlockTextThreeColumn],
["CmsBlockVimeoVideo", LazyCmsBlockVimeoVideo],
["CmsBlockYoutubeVideo", LazyCmsBlockYoutubeVideo],
["CmsBlockHtml", LazyCmsBlockHtml],
["CmsElementCustomForm", LazyCmsElementCustomForm],
["CmsElementHtml", LazyCmsElementHtml],
["CmsElementImageGallery3dPlaceholder", LazyCmsElementImageGallery3dPlaceholder],
["CmsElementImageSlider", LazyCmsElementImageSlider],
["CmsElementManufacturerLogo", LazyCmsElementManufacturerLogo],
["CmsElementProductName", LazyCmsElementProductName],
["CmsElementVimeoVideo", LazyCmsElementVimeoVideo],
["CmsElementYoutubeVideo", LazyCmsElementYoutubeVideo],
["ProductCardSkeleton", LazyProductCardSkeleton],
["AutoComplete", LazyAutoComplete],
["Calendar", LazyCalendar],
["CascadeSelect", LazyCascadeSelect],
["Checkbox", LazyCheckbox],
["CheckboxGroup", LazyCheckboxGroup],
["Chips", LazyChips],
["ColorPicker", LazyColorPicker],
["DatePicker", LazyDatePicker],
["Dropdown", LazyDropdown],
["FloatLabel", LazyFloatLabel],
["Fluid", LazyFluid],
["IconField", LazyIconField],
["IftaLabel", LazyIftaLabel],
["InputChips", LazyInputChips],
["InputGroup", LazyInputGroup],
["InputGroupAddon", LazyInputGroupAddon],
["InputIcon", LazyInputIcon],
["InputMask", LazyInputMask],
["InputNumber", LazyInputNumber],
["InputOtp", LazyInputOtp],
["InputSwitch", LazyInputSwitch],
["InputText", LazyInputText],
["Knob", LazyKnob],
["Listbox", LazyListbox],
["MultiSelect", LazyMultiSelect],
["Password", LazyPassword],
["RadioButton", LazyRadioButton],
["RadioButtonGroup", LazyRadioButtonGroup],
["Rating", LazyRating],
["Select", LazySelect],
["SelectButton", LazySelectButton],
["Slider", LazySlider],
["Textarea", LazyTextarea],
["ToggleButton", LazyToggleButton],
["ToggleSwitch", LazyToggleSwitch],
["TreeSelect", LazyTreeSelect],
["Button", LazyButton],
["ButtonGroup", LazyButtonGroup],
["SpeedDial", LazySpeedDial],
["SplitButton", LazySplitButton],
["Column", LazyColumn],
["Row", LazyRow],
["ColumnGroup", LazyColumnGroup],
["DataTable", LazyDataTable],
["DataView", LazyDataView],
["OrderList", LazyOrderList],
["OrganizationChart", LazyOrganizationChart],
["Paginator", LazyPaginator],
["PickList", LazyPickList],
["Tree", LazyTree],
["TreeTable", LazyTreeTable],
["Timeline", LazyTimeline],
["VirtualScroller", LazyVirtualScroller],
["Accordion", LazyAccordion],
["AccordionPanel", LazyAccordionPanel],
["AccordionHeader", LazyAccordionHeader],
["AccordionContent", LazyAccordionContent],
["AccordionTab", LazyAccordionTab],
["Card", LazyCard],
["DeferredContent", LazyDeferredContent],
["Divider", LazyDivider],
["Fieldset", LazyFieldset],
["Panel", LazyPanel],
["ScrollPanel", LazyScrollPanel],
["Splitter", LazySplitter],
["SplitterPanel", LazySplitterPanel],
["Stepper", LazyStepper],
["StepList", LazyStepList],
["Step", LazyStep],
["StepItem", LazyStepItem],
["StepPanels", LazyStepPanels],
["StepPanel", LazyStepPanel],
["TabView", LazyTabView],
["Tabs", LazyTabs],
["TabList", LazyTabList],
["Tab", LazyTab],
["TabPanels", LazyTabPanels],
["TabPanel", LazyTabPanel],
["Toolbar", LazyToolbar],
["ConfirmDialog", LazyConfirmDialog],
["ConfirmPopup", LazyConfirmPopup],
["Dialog", LazyDialog],
["Drawer", LazyDrawer],
["DynamicDialog", LazyDynamicDialog],
["OverlayPanel", LazyOverlayPanel],
["Popover", LazyPopover],
["Sidebar", LazySidebar],
["FileUpload", LazyFileUpload],
["Breadcrumb", LazyBreadcrumb],
["ContextMenu", LazyContextMenu],
["Dock", LazyDock],
["Menu", LazyMenu],
["Menubar", LazyMenubar],
["MegaMenu", LazyMegaMenu],
["PanelMenu", LazyPanelMenu],
["Steps", LazySteps],
["TabMenu", LazyTabMenu],
["TieredMenu", LazyTieredMenu],
["Message", LazyMessage],
["InlineMessage", LazyInlineMessage],
["Toast", LazyToast],
["Galleria", LazyGalleria],
["Image", LazyImage],
["ImageCompare", LazyImageCompare],
["Avatar", LazyAvatar],
["AvatarGroup", LazyAvatarGroup],
["Badge", LazyBadge],
["BlockUI", LazyBlockUI],
["Chip", LazyChip],
["Inplace", LazyInplace],
["MeterGroup", LazyMeterGroup],
["OverlayBadge", LazyOverlayBadge],
["ScrollTop", LazyScrollTop],
["Skeleton", LazySkeleton],
["ProgressBar", LazyProgressBar],
["ProgressSpinner", LazyProgressSpinner],
["Tag", LazyTag],
["Terminal", LazyTerminal],
["Form", LazyForm],
["FormField", LazyFormField],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
